var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pwl inner-body-block"},_vm._l((_vm.data.pictures),function(item,i){return _c('nuxt-link',{key:i,staticClass:"picture",attrs:{"to":item.href}},[_c('img',{attrs:{"src":'//cdn.triya.ru/upload/' + item.src,"loading":_vm.imageLoadingType}}),_vm._v(" "),_c('span',{staticClass:"link"},[_vm._v(_vm._s(item.label))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }